import React from 'react';
import { LoanQuoteRequirementsProps } from './LoanQuoteRequirements';

export enum DynamicComponentTypes {
  REQUIREMENTS = 'loanQuoteRequirements',
}

export type DynamicComponentPropTypes = LoanQuoteRequirementsProps;

export type DynamicRendererProps = {
  componentName: DynamicComponentTypes.REQUIREMENTS;
  components: {
    loanQuoteRequirements: React.ComponentType<LoanQuoteRequirementsProps>;
  };
  componentProps: LoanQuoteRequirementsProps;
};

const DynamicRenderer = (props: DynamicRendererProps) => {
  switch (props.componentName) {
    case DynamicComponentTypes.REQUIREMENTS: {
      const Component = props.components.loanQuoteRequirements;
      return <Component {...props.componentProps} />;
    }
    default:
      return null;
  }
};

export default DynamicRenderer;
